import React, {
	memo,
	useEffect
} from 'react';
import { Tab } from 'semantic-ui-react';

import { log } from '../../../../../../services/utils';

import { useProgramAction } from '../../../../../../contexts/ProgramsContext';

import TemplatesTable from './TemplatesTable';

const TemplatesTab = () => {
	const { setTemplateModules } = useProgramAction();

	useEffect( () => {
		setTemplateModules();
	}, [ setTemplateModules ] );

	return (
		<Tab.Pane as="div">
			{ log( 'templatesTab' ) }
			<TemplatesTable />
		</Tab.Pane>
	);
};

export default memo( TemplatesTab );
